<template>
  <div class="toast" :class="{ '--visible': visible }" @click="onToastClicked">
    {{ message }}
  </div>
</template>

<script lang="ts">
  import { useToastStore } from "@/store/toast";
  import { defineComponent } from "vue";

  export default defineComponent({
    name: "Toast",

    setup() {
      const toastStore = useToastStore();
      return { toastStore };
    },

    computed: {
      visible(): boolean {
        return this.toastStore.visible ?? false;
      },
      message(): string {
        return this.toastStore.message ?? "";
      }
    },

    methods: {
      onToastClicked(): void {
        // The toast was clicked so hide it
        this.toastStore.hideToast();
      }
    }
  });
</script>

<style scoped lang="scss">
  .toast {
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: fixed;

    background-color: $c--black-chocolate;
    color: $c--white;

    width: 100%;
    height: auto;
    bottom: 0;
    left: 0;
    z-index: $z-index--underneath;
    opacity: 0;
    transform: translateY(100%);

    transition: $animation-length--medium ease-in;

    padding: 25px;

    @include b3;

    &.--visible {
      z-index: $z-index--modal;
      opacity: 1;
      transform: translateY(0);

      transition: $animation-length--medium ease-out;
    }
  }
</style>
